import React from 'react';
import { Box, Typography } from '@mui/material';
import InterviewFlowLogo from './InterviewFlowLogo';

function InterviewFlowCombinedLogo({
  size = 'medium',
  orientation = 'horizontal',
  showTagline = false,
  iconSize = null,
}) {
  const sizeMap = {
    small: {
      fontSize: '1.2rem',
      taglineFontSize: '0.7rem',
      iconSize: 28,
      spacing: 1,
    },
    medium: {
      fontSize: '1.8rem',
      taglineFontSize: '0.8rem',
      iconSize: 36,
      spacing: 1.5,
    },
    large: {
      fontSize: '2.5rem',
      taglineFontSize: '1rem',
      iconSize: 48,
      spacing: 2,
    },
    xlarge: {
      fontSize: '3.5rem',
      taglineFontSize: '1.2rem',
      iconSize: 60,
      spacing: 2.5,
    },
  };

  const currentSize = sizeMap[size] || sizeMap.medium;
  const finalIconSize = iconSize || currentSize.iconSize;

  function LogoText() {
    return (
      <Typography
        variant="h4"
        sx={{
          fontWeight: 800,
          fontSize: currentSize.fontSize,
          background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 30%, #64b5f6 70%, #90caf9 100%)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          letterSpacing: '-0.02em',
          fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
          lineHeight: 1,
        }}
      >
        InterviewFlow
      </Typography>
    );
  }

  function Tagline() {
    return (
      <Typography
        variant="body2"
        sx={{
          fontSize: currentSize.taglineFontSize,
          color: 'text.secondary',
          fontWeight: 500,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          opacity: 0.8,
          lineHeight: 1,
        }}
      >
        Guided Chat Apps
      </Typography>
    );
  }

  if (orientation === 'vertical') {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <InterviewFlowLogo size={finalIconSize} />
        <Box sx={{ mt: currentSize.spacing / 2 }}>
          <LogoText />
        </Box>
        {showTagline && (
          <Box sx={{ mt: currentSize.spacing / 2 }}>
            <Tagline />
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: currentSize.spacing,
      }}
      >
        <InterviewFlowLogo size={finalIconSize} />
        <LogoText />
      </Box>
      {showTagline && (
        <Box sx={{ mt: currentSize.spacing / 2 }}>
          <Tagline />
        </Box>
      )}
    </Box>
  );
}

export default InterviewFlowCombinedLogo;
